<template>
  <basic-dialog
    :show="show"
    @close="$emit('close')"
    max-width="1100px"
    draggable
  >
    <template v-slot:title>{{ title }}</template>

    <v-container fluid class="pa-0">
      <v-row align="center">
        <v-col sm="6">
          <v-text-field
            label="Name"
            v-model="payerName"
            required
            :outlined="outlinedInputs"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col sm="5">
          <v-text-field
            label="Surname"
            v-model="payerSurname"
            required
            :outlined="outlinedInputs"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col sm="1" class="d-flex align">
          <v-menu
            bottom
            left
            :close-on-content-click="true"
            v-model="participantMenu"
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltipOn }">
                    <v-btn
                      icon
                      large
                      v-on="tooltipOn"
                      :disabled="
                        !itineraryParticipants ||
                        itineraryParticipants.length === 0
                      "
                    >
                      <v-icon>mdi-account-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Select Itinerary Participants</span>
                </v-tooltip>
              </div>
            </template>
            <v-card>
              <v-list>
                <v-list-item
                  v-for="(participant, index) in itineraryParticipants"
                  :key="index"
                  @click="onParticipantSelect(participant)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ formatParticipantName(participant) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="3">
          <v-text-field
            label="Amount"
            v-model.number="amount"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col sm="3">
          <currency-list-select
            :outlined="outlinedInputs"
            v-model="currencyCode"
            includeExchangeRate
            @onSelect="onCurrencySelect"
          ></currency-list-select>
        </v-col>
        <v-col>
          <payment-type-select
            v-model="paymentType"
            :outlined="outlinedInputs"
          ></payment-type-select>
        </v-col>
        <v-col v-if="showPaymentMethods"
          ><payment-method-list-select
            v-model="paymentMethodId"
            :outlined="outlinedInputs"
          ></payment-method-list-select
        ></v-col>
      </v-row>
      <v-row>
        <v-col sm="2">
          <date-picker
            customLabel="Lodgement Date"
            @onDateSelected="onDateSelected"
            :gtDateString="lodgementDate"
            :outlined="outlinedInputs"
          ></date-picker>
        </v-col>
        <v-col sm="10">
          <v-text-field
            label="Lodgement Ref"
            v-model="lodgementReference"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col sm="6" v-if="false">
          <v-text-field
            label="Exchange Rate"
            v-model.number="exchangeRate"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="12">
          <v-textarea
            label="Notes"
            v-model="notes"
            :outlined="outlinedInputs"
          ></v-textarea>
        </v-col>
        <div v-if="debug">{{ paymentMethodId }}</div>
      </v-row>
      <v-row v-if="showExported">
        <v-col class="py-0">
          <v-checkbox
            v-model="exported"
            label="Exported"
            class="my-0"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>

    <template v-slot:actions>
      <v-btn text v-if="showXero" @click="onExportToXero">Export to XERO</v-btn>
      <v-btn
        v-if="showQuickBooks"
        @click="onExportToQuickBooks"
        :disabled="
          isValid || $store.getters.hasAccessTo('finances:receipts_view_only')
        "
        >Export to Quick Books</v-btn
      >
      <v-btn
        text
        v-if="showSaveAndExportXero"
        :disabled="
          isValid || $store.getters.hasAccessTo('finances:receipts_view_only')
        "
        @click="onSave('xero')"
        >Save &amp; Export to XERO</v-btn
      >
      <v-btn
        v-if="showSaveAndExportQuickBooks"
        :disabled="
          isValid || $store.getters.hasAccessTo('finances:receipts_view_only')
        "
        @click="onSave('quickbooks')"
        >Save &amp; Export to Quick Books</v-btn
      >
      <v-btn
        color="primary"
        :disabled="
          isValid || $store.getters.hasAccessTo('finances:receipts_view_only')
        "
        @click="onSave()"
        >Save</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";

import DatePicker from "../../../shared/DatePicker";
import CurrencyListSelect from "../../../shared/CurrencyListSelect";
import PaymentTypeSelect from "../../../shared/PaymentTypeSelect";
import PaymentMethodListSelect from "../../../shared/PaymentMethodListSelect.vue";
export default {
  name: "payment-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    itineraryParticipants: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    BasicDialog,
    DatePicker,
    CurrencyListSelect,
    PaymentTypeSelect,
    PaymentMethodListSelect,
  },

  data() {
    return {
      debug: false,
      payerName: this.value ? this.value.payerName : "",
      payerSurname: this.value ? this.value.payerSurname : "",
      amount: this.value ? this.value.amount : 0,
      paymentType: this.value ? this.value.type : "Cash",
      lodgementDate: this.value
        ? this.value.lodgementDate
        : new Date().toISOString(false),
      currencyCode: this.value ? this.value.currencyCode : "",
      exchangeRate: this.value ? this.value.exchangeRate : "",
      notes: this.value ? this.value.notes : "",
      lodgementReference: this.value ? this.value.lodgementReference : "",
      exported: this.value && this.value.exported,
      participantMenu: false,
      paymentMethodId: this.value ? this.value.paymentMethodId : "",
    };
  },

  computed: {
    isValid() {
      return false;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    title() {
      return this.value && this.value.id
        ? `${this.value.itineraryReference}`
        : "Add Receipt";
    },
    showXero() {
      return (
        this.$store.getters.hasAccessTo("finances:xero_export") &&
        this.value &&
        this.value.id
      );
    },
    showQuickBooks() {
      return (
        this.$store.getters.hasAccessTo("finances:quick_books") &&
        this.value &&
        this.value.id
      );
    },
    isNewPayment() {
      return !(this.value && this.value.id);
    },
    showSaveAndExportXero() {
      return (
        this.$store.getters.hasAccessTo("finances:xero_export") &&
        this.isNewPayment
      );
    },
    showSaveAndExportQuickBooks() {
      return (
        this.$store.getters.hasAccessTo("finances:quick_books") &&
        this.isNewPayment
      );
    },
    showExported() {
      return this.$store.getters.hasAccessTo("finances:unexport");
    },
    showPaymentMethods() {
      return this.$store.getters.hasAccessTo("finances:payment_methods");
    },
  },

  watch: {
    value(newVal) {
      this.amount = newVal.amount;
      this.currencyCode = newVal.currencyCode;
      this.payerName = newVal.payerName;
      this.payerSurname = newVal.payerSurname;
      this.paymentType = newVal.type;
      this.paymentMethodId = newVal.paymentMethodId;
      this.notes = newVal.notes;
      this.lodgementDate = newVal.lodgementDate;
      this.exchangeRate = newVal.exchangeRate;
      this.lodgementReference = newVal.lodgementReference;
      this.exported = newVal.exported;
    },
  },

  methods: {
    onExportToQuickBooks() {
      this.$emit("export-to-quickbooks", { ...this.value });
    },
    onExportToXero() {
      this.$emit("export-to-xero", { ...this.value });
    },
    onSave(exportTo = null) {
      this.$emit(
        "save",
        {
          id: this.value ? this.value.id : undefined,
          payerName: this.payerName,
          payerSurname: this.payerSurname,
          amount: Number(this.amount),
          currencyCode: this.currencyCode,
          exchangeRate: Number(this.exchangeRate),
          paymentMethodId: this.paymentMethodId,
          notes: this.notes,
          lodgementReference: this.lodgementReference,
          lodgementDate:
            this.lodgementDate != "" ? this.lodgementDate : undefined,
          type: this.paymentType,
          exported: this.showExported ? this.exported : undefined,
        },
        exportTo
      );
    },
    onDateSelected(payload) {
      //console.log("on date selected", payload);
      this.lodgementDate = payload;
    },
    onCurrencySelect(payload) {
      //console.log("currency selected", payload);
      this.exchangeRate = payload.exchangeRate;
    },
    onParticipantSelect(participant) {
      this.payerName = participant.name || "";
      this.payerSurname = participant.surname || "";
      this.participantMenu = false;
    },
    formatParticipantName(participant) {
      const parts = [];
      if (participant.title) parts.push(participant.title);
      if (participant.name) parts.push(participant.name);
      if (participant.surname) parts.push(participant.surname);
      return parts.length > 0 ? parts.join(" ") : "Unknown";
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/payments/new/PaymentEditDialog.vue